import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { PageNotFoundComponent } from './pages/page-not-found-component/page-not-found-component.component';
import { VideoStoreLoginComponent } from './pages/video-store-login/video-store-login.component';
import { VideoStoreLoginLegacyComponent } from './pages/video-store-login-legacy/video-store-login-legacy.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { TermsAndConditionsComponent } from './pages/terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';





const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'video-store-dashboard', component: DashboardComponent },
  { path: 'login', component: VideoStoreLoginComponent },
  { path: 'login-new-design', redirectTo: 'login-old-design', pathMatch: 'full' },
  { path: 'login-old-design', component: VideoStoreLoginLegacyComponent },
  { path: 'contact', component: ContactUsComponent },
  {path:'terms',component:TermsAndConditionsComponent},
  {path:'privacy-policy',component:PrivacyPolicyComponent},
  { path: '404', component: PageNotFoundComponent },
  { path: '**', component: PageNotFoundComponent },
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
